import axiosInstance from '../axios/axiosInstance';
import { Page, Tag } from '../model/response';
import { TableParams, TagRequest } from '../model/request';

export const findAllTags = async () => {
  const { data } = await axiosInstance.get<Tag[]>('tags', { params: { fromCMS: true } });
  return data;
};

export const getPageTag = async (tableParams: TableParams, keyword: string) => {
  const params = {
    size: tableParams.pagination ? tableParams.pagination.pageSize : 10,
    page: tableParams.pagination && tableParams.pagination.current ? tableParams.pagination.current - 1 : 0,
    keyword,
    fromCMS: true,
  };
  const { data } = await axiosInstance.get<Page<Tag>>('tags/page', {
    params: params,
  });
  return data;
};

export const findTagById = async (id: string) => {
  const { data } = await axiosInstance.get<Tag>('tags/' + id);
  return data;
};

export const updateTag = async (id: string, tagRequest: TagRequest): Promise<void> => {
  await axiosInstance.put<string>(`tags/${id}`, tagRequest);
};

export const createTag = async (tagRequest: TagRequest): Promise<string> => {
  const { data } = await axiosInstance.post<string>(`tags`, tagRequest);
  return data;
};

export const deleteTag = async (id: string) => {
  await axiosInstance.delete<void>('tags/' + id);
};
